import { Link } from 'react-router-dom';

type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
};

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b border-background-200 pb-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          <span className="inline-block h-5 w-1 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {moreLabel} <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}